//View Keys
export default {
  alertsNewAlert_optionsTab: 'Options',
  alertsNewAlert_title: 'New Alert',
  alertsNewAlert_EditTitle: 'Save Alert',
  alertsNewAlert_placeholderEnterLabel: 'Enter Label',
  alertsNewAlert_enterLabel: 'Alert Label',
  alertsNewAlert_buttonBack: 'Back',
  alertsNewAlert_buttonNext: 'Next',
  alertsNewAlert_triggersLabel: 'Triggers',
  alertsNewAlert_minutesLabel: 'Minutes',
  alertsNewAlert_hoursLabel: 'Hours',
  alertsNewAlert_allowIdlingWhenPTO: "Allow idling when PTO/inputs are ON",
  alertsNewAlert_evaluateLandmarkTrigger: "Evaluate current landmark before triggering this alert",
  alertsNewAlert_insideLandmark: "Inside",
  alertsNewAlert_outsideLandmark: "Outside",
  alertsNewAlert_impactDetectedLabel: 'Impact Detected',
  alertsNewAlert_panicButtonLabel: 'Panic Button',
  alertsNewAlert_searchLabel: "Search",
  alertsNewAlert_startTimeLabel: "Start Time",
  alertsNewAlert_endTimeLabel: "End Time",
  alertsNewAlert_schedulingFrequencyTab: 'Scheduling & Frequency',
  alertsNewAlert_applyModaysTimesToAll: 'Apply Monday\'s times to all',
  alertsNewAlert_aletTriggerOptions: 'Alert Trigger Options',
  alertsNewAlert_applyEveryEvent: 'Every Event',
  alertsNewAlert_hourlySummary: 'Hourly Summary',
  alertsNewAlert_hourlySummary_message: "This alert will trigger immediately for any assigned unit that reports the selected events during the monitored hours. All contacts will receive the initial event and location followed by a summary alert sent every hour until the behavior stops.",
  alertsNewAlert_alertAfter: 'Alert After',
  alertsNewAlert_alertAfterConsecutive: 'Send alert after how many consecutive events?',
  alertsNewAlert_totalDailyLimit: 'Set a total daily limit?',
  alertsNewAlert_maxAlertPerDay: 'Max Alert Per Day',
  alertsNewAlert_receiveTheseAlertLabel: 'How often would you like to receive these alerts?',
  alertsNewAlert_buttonCancel: 'Cancel',
  alertsNewAlert_batteryVoltage: 'Battery voltage is less than',
  alertsNewAlert_coolantTempIs: 'Coolant Temp is',
  alertsNewAlert_engineSpeedIsGreaterThan: 'Engine speed is greater than',
  alertsNewAlert_fuelLevelIsLessThan: 'Fuel level is less than',
  alertsNewAlert_fuelRemainingIsLessThan: 'Fuel remaining is less than',
  alertsNewAlert_throttlePositionIsGreaterThan: 'Throttle position is greater than',
  alertsNewAlert_seatbeltFastenedAtSpeedsGreaterThan: 'Seatbelt fastened at speeds greater than',
  alertsNewAlert_odometer: 'Odometer',
  alertsNewAlert_triggerAlertWhen: 'Trigger alert when:',
  alertsNewAlert_immediateLabel: 'Immediate',
  alertsNewAlert_daysLabel: 'Days',
  alertsNewAlert_subscribersTab: 'Subscribers',
  alertsNewAlert_drivingHoursExceededLabel: 'Driving exceeded',
  alertsNewAlert_whoShouldReceiveTheseAlertsLabel: 'Who should receive these alerts',
  alertsNewAlert_selectPlaceholder: 'Select',
  alertsNewAlert_smsLabel: 'SMS',
  alertsNewAlert_emailLabel: 'Email',
  alertsNewAlert_webLabel: 'Web',
  alertsNewAlert_howWouldYouLikeToReceiveTheseAlertLabel: 'How would you like to receive these alerts?',
  alertsNewAlert_selectAllContactsLabel: 'Select All Contacts',
  alertsNewAlert_everydayLabel: 'Everyday',
  alertsNewAlert_weekdaysLabel: 'Weekdays',
  alertsNewAlert_weekendsLabel: 'Weekends',
  alertsNewAlert_customLabel: 'Custom',
  alertsNewAlert_whenShouldThisAlertTriggerLabel: 'When should this alert trigger?',
  alertsNewAlert_assignUnitsTab: 'Assign Units',
  alertsNewAlert_selectUnitsOrDrivers: 'Select Units or Drivers',
  alertsNewAlert_selectUnits: 'Select Units',
  alertsNewAlert_all: 'All',
  alertsNewAlert_units: 'Units',
  alertsNewAlert_unitGroup: 'Unit Groups',
  alertsNewAlert_drivers: 'Drivers',
  alertsNewAlert_driverGroup: 'Driver Groups',
  alertsNewAlert_singleUnits: 'Single Units',
  alertsNewAlert_addNewButton: 'Add New',
  alertsNewAlert_editButton: 'Save',
  alertsNewAlert_minutes: 'Minutes',
  alertsNewAlert_enter: 'Enter',
  alertsNewAlert_exit: 'Exit',
  alertsNewAlert_both: 'Both',
  alertsNewAlert_insideDuration: 'Inside Duration',
  alertsNewAlert_immediate: 'Immediate',
  alertsNewAlert_hours: 'Hours',
  alertsNewAlert_day: 'Day',
  alertsNewAlert_days: 'Days',
  alertsNewAlert_recurring: 'Recurring',
  alertsNewAlert_onlyOnce: 'Only Once',
  alertsNewAlert_vehicleSpeed: 'Vehicle Speed',
  alertsNewAlert_postedSpeed: 'Over Posted Speed (over posted speed limit by)',
  alertsNewAlert_postedSpeedOem: 'OEM Speeding',
  alertsNewAlert_postedSpeed_operator_And: "AND",
  alertsNewAlert_postedSpeed_operator_Or: "OR",
  alertsNewAlert_whileWhithinALandmark: 'While within a landmark',
  alertsNewAlert_createdMessage: 'Alert Created',
  alertsNewAlert_editedMessage: 'Alert Edited',
  alertsNewAlert_titleErrorMessage: 'Error',
  alertsNewAlert_ErrorMessage: 'Could not create the alert',
  alertsNewAlert_Alert_duplicated_name: 'Alert label already exists',
  alertsNewAlert_LowTitle: 'Low',
  alertsNewAlert_MediumTitle: 'Medium',
  alertsNewAlert_HighTitle: 'High',
  alertsNewAlert_AllTitle: 'ALL',
  alertsNewAlert_SetSeverity: 'Set Alert Severity',
  alertsNewAlert_SpeedValidation: 'Vehicle speed trigger required',
  alertsNewAlert_DriveTimeValidation: 'end time must be after start time',
  alertsNewAlert_SpeedTriggersValidation: 'Please select at least one landmark trigger',
  alertsNewAlert_SpeedUnitMph: "MPH",
  alertsNewAlert_Parameters: "Parameters",
  alertsNewAlert_Over: "Over",
  alertsNewAlert_SelectEventValidation: "Please select an event",
  alertsNewAlert_MediaTriggersValidation: 'Must Select at least one trigger',
  alertsNewAlert_TotalDriverTimeTriggersValidation: 'The start time should not be greater than the end time',
  alertsNewAlert_Selected: "Selected",
  alertsNewAlert_SelectLandmarks: "Select Landmark(s)",
  alert_numberOfUnitsAllowedLandmarkLabel: "Number of units allowed in the same landmark",
  alertsNewAlert_unitsValidation: "Please select at least a unit",
  alertsNewAlert_driversValidation: "Please select at least a driver",
  alertsNewAlert_itemValidation: "Please select at least a item",
  alertsNewAlert_triggerValidation: "Please select one or more triggers",
  alertsNewAlert_triggerValidationLandmarks: "Please select one or more landmarks",
  alertsNewAlert_triggerValidationOem: "Triggers OEM",
  alertsNewAlert_landmarkValidation: "Select 1 or more Landmarks",
  alertsNewAlert_timeValidation: "Start Time must be greater than End Time",
  alertsNewAlert_expandButtonLabel: "Show All",
  alertsNewAlert_collapseButtonLabel: "Collapse",
  alertsNewAlert_generalTab: 'General',
  alertsNewAlert_customScheduleValidation: "Please select at least a schedule day",
  alertsNewAlert_unassignedDriver: 'Unassigned Driver',
  alertsNewAlert_M: 'M',
  alertsNewAlert_T: 'T',
  alertsNewAlert_W: 'W',
  alertsNewAlert_Th: 'Th',
  alertsNewAlert_F: 'F',
  alertsNewAlert_S: 'S',
  alertsNewAlert_Su: 'Su',

  alertsNewAlert_warning: 'Warning!',
  alertsNewAlert_noRangeSelected: 'It is necessary to select a time frequency for this alert in the scheduling & frequency step',




  // Driver behavior Alert
  alertsNewAlert_SelectEvents: "Select events that will trigger the alert",
  alertsNewAlert_EventValidation: "Please select one or more events",


  // Fuel Card Alert
  alertsNewAlert_Event: "Event",
  alertsNewAlert_Overfill: "Overfill",
  alertsNewAlert_NotAtLocation: "Not At Location",
  alertsNewAlert_SelectPlaceholder: "Select",

  // Driver Behavior
  alertsNewAlert_SuddenStop: "Sudden Stop",
  alertsNewAlert_PotentialIncident: "Potential Incident",
  alertsNewAlert_HardStop: "Hard Stop",
  alertsNewAlert_HardTurn: "Hard Turn",
  alertsNewAlert_RapidAcceleration: "Rapid Acceleration",

  // Off Hour
  alertsNewAlert_Ignition: "Ignition",
  alertsNewAlert_Drive: "Drive",
  alertsNewAlert_Input: "Input",
  alertsNewAlert_Geofence: "Geofence",
  alertsNewAlert_Landmark: "Landmark",
  alertsNewAlert_OverlappingDatesErrorMessage: "Please check, the times shouldn't be overlapped",
  alertsNewAlert_HoursCompletationValidation: "Please complete the ranges of hours by selecting the final time greater than the initial one.",
  alertsNewAlert_RequiredAtLeastADay: "Please select at least one range.",

  // On Event
  alertsNewAlert_MainPowerOff: "Main Power Off",
  alertsNewAlert_MainPowerOn: "Main Power On",
  alertsNewAlert_MainPowerDisconnect: "Main Power Disconnect",
  alertsNewAlert_AntennaDisconnect: "Antenna Disconnect",
  alertsNewAlert_AntennaConnect: "Antenna Connect",
  alertsNewAlert_InternalBatteryDisconnect: "Internal Battery Disconnect",
  alertsNewAlert_InternalBatteryConnect: "Internal Battery Connect",
  alertsNewAlert_Input1: "Input 1",
  alertsNewAlert_Input2: "Input 2",
  alertsNewAlert_Input3: "Input 3",
  alertsNewAlert_Input4: "Input 4",
  alertsNewAlert_Input5: "Input 5",
  alertsNewAlert_InputLabel: "Input",
  alertsNewAlert_State: "State",
  alertsNewAlert_On: "On",
  alertsNewAlert_Off: "Off",
  alertsNewAlert_Driving: "Is Driving",
  alertsNewAlert_NotDriving: "Not Driving",
  alertsNewAlert_Both: "Both",
  alertsNewAlert_ValidationInputEvent: "Please select at least an Input.",
  alertsNewAlert_CellJammingStart: "Cell Jamming Start",
  alertsNewAlert_GPSJammingStart: "GPS Jamming Start",
  alertsNewAlert_JammingStop: "Jamming Stop",
  //new
  alertsNewAlert_Update: "Update",
  alertsNewAlert_IgnitionOn: "Ignition On",
  alertsNewAlert_IgnitionOff: "Ignition Off",
  alertsNewAlert_Ping: "Ping",
  alertsNewAlert_Motion: "Motion",
  alertsNewAlert_LowBattery: "Low Battery",
  alertsNewAlert_TamperSensor: "Tamper Sensor",
  alertsNewAlert_UserUpdate: "User Update",
  alertsNewAlert_LightSensor: "Light Sensor",

  // Alerts summaries
  alertsNewAlert_ConsistentSpeedSummary: "Holds {speed} {units} for 4 min",
  alertsNewAlert_StoppedReportingOverSummary: "Over",
  alertsNewAlert_SpeedSummarySpeedMessage: "Speed over {speed} {speedMeasure}",
  alertsNewAlert_SpeedSummarySpeedMessageAnd: "and",
  alertsNewAlert_SpeedSummarySpeedMessageOr: "or",
  alertsNewAlert_SpeedSummaryPostedSpeedMessage: "Posted Speed over {postedSpeed} {speedMeasure}",
  alertsNewAlert_SpeedSummaryInsideLandmark: "Inside landmark(s)",
  alertsNewAlert_OnEventSummaryEventWithInputs: "Selected Inputs: {inputs}",
  alertsNewAlert_StopSummary: "Trigger: {trigger}",
  alertsNewAlert_StopReportingSummary: "Trigger: {trigger} - Camera Trigger:{cameraTrigger}",
  alertsNewAlert_VehicleCongregationAllowed: "{allowedUnits} unit(s)",
  alertsNewAlert_VehicleCongregationLandmark: "allowed in {landmarkEntityTitle} {landmarks}",
  alertsNewAlert_MediaSummary: "Trigger when: {trigger}",
  alertsNewAlert_MediaSummaryBothTriggers: "{triggerOne} or {triggerTwo}",
  alertsNewAlert_IdleSummary: "Trigger: {trigger}{IdlingAllowed}",
  alertsNewAlert_IdleSummaryAllowedIdling: ", Allowed idling when PTO/inputs are ON",
  alertsNewAlert_IdleSummaryNotAllowedIdling: ", NOT allowed idling when PTO/inputs are ON",
  alertsNewAlert_TotalDriveTimeSummary: "From {startTime} to {endTime}, {drivingHoursExceeded} driving exceeded hours.",
  alertsNewAlert_LandmarksSummary: "Selected {landmarkEntity}(s): {landmarks}, Trigger {trigger}",
  alertsNewAlert_LandmarksSummaryNoLandmarks: "No landmarks selected",
  alertsNewAlert_LandmarksSummaryAllLandmarks: "All landmarks selected",
  alertsNewAlert_LandmarkGroup: "Landmark group",
  alertsNewAlert_Landmark_name: "Landmark",
  alertsNewAlert_Landmark_all: "All",
  alertsNewAlert_GeofencesSummaryNoLandmarks: "No Geofences selected",
  alertsNewAlert_GeofencesSummaryAllLandmarks: "All Geofences selected",
  alertsNewAlert_Geofence: "Geofence",
  alertsNewAlert_Tag: "Tag",
  alertsNewAlert_GeofencesSummary: "Selected {geofenceEntity}(s): {geofences}, Trigger {trigger}",

  // Alerts Landmarks
  alertsNewAlert_landmarkTriggersValidation: 'Please select at least one landmark trigger',
  alertsNewAlert_landmarkValidation: 'Please select at least one landmark',

  //events for new alert
  alertsNewAlert_CameraEvent: 'Camera Event',
  alertsNewAlert_OnEvent: 'On Event',
  alertsNewAlert_ConsecutiveDriving: 'Consecutive Driving',
  alertsNewAlert_ConsistentSpeed: 'Consistent Speed',
  alertsNewAlert_DriverBehavior: 'Driver Behavior',
  alertsNewAlert_FuelCard: 'Fuel Card',
  alertsNewAlert_HeavyDutyDTC: 'Heavy Duty Diagnostics',
  alertsNewAlert_Idle: 'Idle',
  alertsNewAlert_LightDutyDTC: 'Light Duty Diagnostics',
  alertsNewAlert_OBDII: 'OBDII',
  alertsNewAlert_Media: 'Media',
  alertsNewAlert_OffHour: 'Off Hour',
  alertsNewAlert_SmartOneCLowBattery: 'Smart One CLow Battery',
  alertsNewAlert_Speed: 'Speed',
  alertsNewAlert_Stationary: 'Stationary',
  alertsNewAlert_Stop: 'Stop',
  alertsNewAlert_StoppedReporting: 'Stopped Reporting',
  alertsNewAlert_TotalDriveTime: 'Total Drive Time',
  alertsNewAlert_Tow: 'Tow',
  alertsNewAlert_UnassignedDriver: 'Unassigned Driver',
  alertsNewAlert_VehicleCongregation: 'Vehicle Congregation',
  alertsNewAlert_FSMMealBreak: 'FSM Meal Break',
  alertsNewAlert_OBDIIAlerts: 'OBDII Alerts',
  alertsNewAlert_OnLandmark: 'On Landmark',
  alertsNewAlert_OnLandmarkEnter: 'On Landmark Enter',
  alertsNewAlert_OnLandmarkExit: 'On Landmark Exit',
  alertsNewAlert_stop: 'On Stop',
  alertsNewAlert_OverPostedSpeed: 'Over Posted Speed',
  alertsNewAlert_OverPostedSpeed: 'On Stop',

  alertsNewAlert_currentDriver: 'Current driver',

  alertsNewAlert_tab_unit_units: "Units",
  alertsNewAlert_tab_unit_drivers: "Drivers",
  alertsNewAlert_tab_unit_all: "All",

  alertsNewAlert_notifyAt: "Notify At",
  alertsNewAlert_breakDuration: "Break Duration",

  alertsNewAlert_ELD150MilesRule: 'ELD 150 Miles Rule',

  //Routes (Watchers) Alert
  alertsNewAlert_RouteWatchers: "Routes (Watchers)",
  alertsNewAlert_RouteWatchers_RouteDeviation: "Route Deviation",
  alertsNewAlert_RouteWatchers_startRoute: "Start Route",
  alertsNewAlert_RouteWatchers_endRoute: "End Route",
  alertsNewAlert_RouteWatchers_alertMessage: "The subscribers to this alert are set up in the Watcher tab in the Routes Module",

  alertsNewAlert_Warning: "Warning",


  alertsNewAlert_4GOfflineOver24Hours: "Wireless Signal Lost Over 24 Hours",
  alertsNewAlert_SDCardStatus: "SD Card Error",
  alertsNewAlert_ReplaceSDCard: "Replace SD Card",
  alertsNewAlert_PowerDisconnect: "Power Disconnect",
  alertsNewAlert_MCUDisconnected: "MCU Disconnected",
  alertsNewAlert_LowVBUSVoltage: "Low VBUS Voltage",
  alertsNewAlert_LowBattery: "Low Battery",
  alertsNewAlert_HDOPQuality: "HDOP Quality",
  alertsNewAlert_GPSGapTooLarge: "GPS Gap Too Large",
  alertsNewAlert_FormatSDCard: "Format SD Card",
  alertsNewAlert_FailedToEnterStandby: "Failed To Enter Standby",
  alertsNewAlert_DrivingOver18Hours: "Drive Detected for Over 18 Hours",
  alertsNewAlert_CommLost: "Comm Lost",
  alertsNewAlert_CameraDisconnectedFromServerOver7Days: "Camera Disconnected From Server Over 7 Days",
  alertsNewAlert_BatteryVoltageLow: "Battery Voltage Low",
  alertsNewAlert_AuxCamDisconnected: "Aux camera disconnected",
  alertsNewAlert_All: "All",

  //Warnings
  alertsNewAlert_WarningsValidation: "Please select one or more warnings",
  alertsNewAlert_SetWarnings: "Set Warnings",
  alertsNewAlert_Warnings: "Warnings",

  //FuelLevel - Fuel Changes
  alertsNewAlert_FuelLevel: "Fuel Changes",
  alertsNewAlert_FuelLevelReduce: "Fuel Level reduced by",
  alertsNewAlert_FuelLevelIncrease: "Fuel Level increased by",
  alertsNewAlert_dropping: "Fuel Level reduced by",
  alertsNewAlert_raising: "Fuel Level increased by",

  //Emission Check
  alertsNewAlert_EmissionCheck: 'Emission Check',
  alertsNewAlert_Status: "Status",
  alertsNewAlert_NotRegistered: "Not Registered",
  alertsNewAlert_Waiting: "Waiting",
  alertsNewAlert_Compliant: "Compliant",
  alertsNewAlert_NotCompliant: "Not Compliant",

  //VBus
  alertsNewAlert_VBus_SystemIndicators: "System Indicators",
  alertsNewAlert_VBus_Thresholds: "Thresholds",
  alertsNewAlert_VBus_EngineCode: "Engine Code (DTC)",
  alertsNewAlert_VBus_AbsActiveLamp: "ABS Active Lamp",
  alertsNewAlert_VBus_Abs: "ABS Indicator",
  alertsNewAlert_VBus_AirbagIndicator: "Air Bag Indicator",
  alertsNewAlert_VBus_BrakeIndicator: "Brake Indicator",
  alertsNewAlert_VBus_OilPressure: "Oil Pressure",
  alertsNewAlert_VBus_CoolantHotLight: "Coolant Hot Light",
  alertsNewAlert_VBus_CruiseControl: "Cruise Control",
  alertsNewAlert_VBus_MilStatus: "MIL Status",
  alertsNewAlert_VBus_PtoStatus: "PTO Status",
  alertsNewAlert_VBus_BrakeSwitchStatus: "Brake Switch Status",
  //alertsNewAlert_VBus_IgnitionStatus: "Ignition Status",
  alertsNewAlert_VBus_BatteryVoltage: "Battery Voltage (V) <=",
  alertsNewAlert_VBus_CoolantTemp: "Coolant Temp (°F) >=",
  alertsNewAlert_VBus_EngineSpeed: "Engine Speed (RPM) >=",
  alertsNewAlert_VBus_FuelPercent: "Fuel Level (%) <=",
  alertsNewAlert_VBus_FuelRemain: "Fuel Remaining (gal) <=",
  alertsNewAlert_VBus_TripFuel: "Trip Fuel Consumption (gal) >=",
  //alertsNewAlert_VBus_Odometer: "Odometer",
  alertsNewAlert_VBus_FuelRate: "Fuel Rate (gal/hr) >=",
  alertsNewAlert_VBus_ThrottlePosition: "Throttle Position (%) >=",
  //alertsNewAlert_VBus_TripOdometer: "Trip Odometer",
  alertsNewAlert_VBus_Seatbelt: "Seatbelt Unfastened (SPEED_UM) >=",

  //General VBus/JBus
  alertsNewAlert_Bus_DiagnosticTroubleshootingCodes: "Diagnostic Troubleshooting Codes",
  alertsNewAlert_Bus_NotSet: "Not Set",
  alertsNewAlert_BusValidation: "Please select one or more triggers",
  alertsNewAlert_Bus_NotAllFieldsAvailableToAlert: "Not all vehicles provide ECU-connected devices with all diagnostic data displayed below",

  //JBus
  alertsNewAlert_JBus_General: "General",
  alertsNewAlert_JBus_Pedals: "Pedals",
  alertsNewAlert_JBus_LampIndicators: "Lamp Indicators",
  alertsNewAlert_JBus_Coolant: "Engine Coolant",
  alertsNewAlert_JBus_Oil: "Engine Oil",
  alertsNewAlert_JBus_Fuel: "Engine Fuel",
  alertsNewAlert_JBus_Brakes: "Brakes",
  alertsNewAlert_JBus_Dtc: "Engine Code (DTC)",
  alertsNewAlert_JBus_RedStopLampStatus: "Amber warning lamp",
  alertsNewAlert_JBus_AmberWarningLamp: "Flash amber warning lamp",
  alertsNewAlert_JBus_ProtectLampStatus: "Flash malfunction indicator lamp",
  alertsNewAlert_JBus_FlashMalfunctionIndicatorLamp: "Flash protect lamp",
  alertsNewAlert_JBus_FlashRedStopLamp: "Flash red stop lamp",
  alertsNewAlert_JBus_FlashAmberWarningLamp: "Protect lamp status",
  alertsNewAlert_JBus_FlashProtectLamp: "Red stop lamp status",
  alertsNewAlert_JBus_BatteryVoltage: "Battery Voltage (V) <",
  alertsNewAlert_JBus_EngineCrankCasePressure: "Eng Crankcase Pressure (PSI) >=",
  //alertsNewAlert_JBus_Odometer: "Odometer (Miles) >",
  alertsNewAlert_JBus_Rpm: "Engine RPM >=",
  alertsNewAlert_JBus_Ok: "Ok",
  alertsNewAlert_JBus_NotBucklet: "Not Buckled",
  alertsNewAlert_JBus_Error: "Error",
  alertsNewAlert_JBus_Off: "Off",
  alertsNewAlert_JBus_On: "On",
  alertsNewAlert_JBus_Active: "Active",
  alertsNewAlert_JBus_Inactive: "Inactive",
  alertsNewAlert_JBus_Flashing: "Flashing",
  alertsNewAlert_JBus_Seatbelt: "Seatbelt Unfastened (SPEED_UM) >=",
  alertsNewAlert_JBus_Hazard: "Hazard",
  alertsNewAlert_JBus_AcceleratorPedalPosition: "Accel Pedal Position (%) >=",
  alertsNewAlert_JBus_BrakePedalPosition: "Brake Pedal Position (%) >=",
  alertsNewAlert_JBus_BrakeSystemSwitchStatus: "Brake System Switch Status",
  alertsNewAlert_JBus_ServiceBrakeSwitchStatus: "Service Brake Switch Status",
  alertsNewAlert_JBus_ParkingBrakeSwitch: "Parking Brake Switch",
  alertsNewAlert_JBus_EngineCoolantLevel: "Level (%) <=",
  alertsNewAlert_JBus_EngineCoolantPressure: "Pressure (PSI) >=",
  alertsNewAlert_JBus_EngineCoolantTemp: "Temperature (°F) >=",
  alertsNewAlert_JBus_EngineOilLevel: "Level (%) <=",
  alertsNewAlert_JBus_EngineOilPressure: "Pressure (PSI) >=",
  alertsNewAlert_JBus_EngineOilTemp: "Temperature (°F) >=",
  alertsNewAlert_JBus_EngineFuelRate: "Fuel Rate (gal/hr) >",
  alertsNewAlert_JBus_FuelLevelOne: "Fuel Level 1 (%) <=",
  alertsNewAlert_JBus_FuelLevelTwo: "Fuel Level 2 (%) <=",

  //CARB
  alertsNewAlert_CARB_ScansReturningError: "Scans returning error",
  alertsNewAlert_CARB_CARBSubmissionFail: "CARB Submission fail",
  alertsNewAlert_CARB_AssetAtRisk: "Asset at-risk (days)",
  alertsNewAlert_CARB_DaysBeforeComplianceDeadline: "Days before compliance deadline",
  alertsNewAlert_CARB_AssetIsNotCompliant: "Asset is not compliant (days)",
  alertsNewAlert_CARB_DaysAfterDeadlineSubmission: "Days after the deadline without a success submission",

  // Inspection
  alertsNewAlert_Inspection: "Inspection",
  alertsNewAlert_TriggerType: "Trigger Type",
  alertsNewAlert_TriggerTypePlaceholder: "Select Trigger Type",
  alertsNewAlert_InspectionDefects: "Inspection Defects",
  alertsNewAlert_InspectionStatus: "Inspection Status",
  alertsNewAlert_InspectionDuration: "Inspection Duration",
  alertsNewAlert_OptionalFilters: "Optional Filters",
  alertsNewAlert_ApplyToSpecificInspectionConfigType: "Apply to specific Inspection Config Type",
  alertsNewAlert_SelectInspectionConfigTypes: "Select Inspection Config Types",
  alertsNewAlert_PreTripInspection: "Pre-Trip Inspection",
  alertsNewAlert_PostTripInspection: "Post-Trip Inspection",
  alertsNewAlert_AnnualInspection: "Annual Inspection",
  alertsNewAlert_90DayInspection: "90-Day Inspection",
  alertsNewAlert_DailyInspection: "Daily Inspection",
  alertsNewAlert_MonthlyInspection: "Monthly Inspection",
  alertsNewAlert_IncompleteInspection: "Incomplete Status",
  alertsNewAlert_UnverifiedInspection: "Unverified Status",
  alertsNewAlert_DefectSeverity: "Defect Severity",
  alertsNewAlert_Critical: "Critical",
  alertsNewAlert_Minor: "Minor",
  alertsNewAlert_CriticalDefect: "Critical Defect",
  alertsNewAlert_MinorDefect: "Minor Defect",
  alertsNewAlert_InspectionUnderDuration: "Under Duration",
  alertsNewAlert_InspectionOverDuration: "Over Duration",
  alertsNewAlert_IncludeAllComponents: "Include all components",
  alertsNewAlert_SelectComponents: "Select Components",
  alertsNewAlert_Brakes: "Brakes",
  alertsNewAlert_Tires: "Tires",
  alertsNewAlert_Lights: "Lights",
  alertsNewAlert_Engine: "Engine",
  alertsNewAlert_Transmission: "Transmission",
  alertsNewAlert_Steering: "Steering",
  alertsNewAlert_Suspension: "Suspension",
  alertsNewAlert_Body: "Body",
  alertsNewAlert_SafetyEquipment: "Safety Equipment",
  alertsNewAlert_InspectionType: "Inspection Type",
  alertsNewAlert_Any: "Any",
  alertsNewAlert_PreTrip: "Pre-Trip",
  alertsNewAlert_PostTrip: "Post-Trip",
  alertsNewAlert_ThresholdType: "Threshold Type",
  alertsNewAlert_Under: "Under",
  alertsNewAlert_ExpectedDurationMinutes: "Expected Duration (minutes)",
  alertsNewAlert_InspectionDefects_Message: "Alert will trigger when a {defectSeverities} defect is reported in any inspection.",
  alertsNewAlert_InspectionStatus_Message_NoStatuses: "Select at least one inspection status to see alert preview.",
  alertsNewAlert_InspectionStatus_Message: "Alert will trigger when an inspection is {inspectionStatuses}.",
  alertsNewAlert_InspectionDuration_Message: "Alert will trigger when an inspection falls outside expected duration threshold.",
  alertsNewAlert_FirstOfDay: "First of Day",
  alertsNewAlert_InspectionAlertsEvaluateOnlyTripsAndInspectionsThatOccurWithinActiveHours: "Inspection alerts evaluate only trips and inspections that occur within active hours.",
  alertsNewAlert_DriversMustBeAssignedInPXToReceiveAlertsDirectly: "Drivers must be assigned in PX to receive alerts directly.",
  alertsNewAlert_InspectionStatusesValidation: "Please select at least one inspection status"
};
